import { useQuery } from "@tanstack/react-query";

import { useCurrentCompanyId } from "@/hooks/useCurrentCompanyId";
import { guacHttpClient } from "@/lib/http";
import { CompanyFile, HttpResponse } from "@/types";

export function useGetCompanyFiles() {
  const currentCompanyId = useCurrentCompanyId();

  return useQuery({
    queryKey: ["files", currentCompanyId],
    queryFn: async () => {
      const path = `companies/${currentCompanyId}/files`;
      const res = await guacHttpClient.get<
        CompanyFile[],
        HttpResponse<CompanyFile[]>
      >(path);
      return res.data;
    },
  });
}
